import {join} from '../utils';
import styles from './icon.module.less';

type Props = {
	toggled: boolean;
	color?: string;
}

export function ExpandIcon(props: Props) {
  return <div className="expand-icon">
    <svg className={join(styles.expandIcon, props.toggled && styles.toggled)} width='10' height='6'
         viewBox='0 0 10 6' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path d='M0 5.11133L5 -2.86102e-06L10 5.11133H0Z' fill={props.color ? props.color : '#828282'} />
    </svg>
  </div>;
}
